export default __webpack_public_path__ + "static/media/Long Call.4a238b2d.svg";